import { SharedModule } from '../../shared/shared.module';
import { NewNavBarComponent } from '../new-nav-bar/new-nav-bar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NewListaDiagramasRoutingModule } from './new-lista-diagramas-routing.module';
import { NewListaDiagramasViewComponent } from './new-lista-diagramas-view/new-lista-diagramas-view.component';


@NgModule({
  declarations: [NewListaDiagramasViewComponent],
  imports: [
    CommonModule,
    NewListaDiagramasRoutingModule,
    SharedModule
  ]
})
export class NewListaDiagramasModule { }
